
<template>
<div>
  <chc-header :noLogin="true"></chc-header>
  <navbar :noLogin="true"></navbar>
  <section v-if="!data.goodToken">
    <div class="field">
      Error, registration not valid.
    </div>
  </section>
  <section v-else-if="true">
    <div class="field">
      <h1>Welcome!</h1>
      <p>Welcome to the Cars Helping Charities Vehicle Donation Cloud. Please follow the instructions below to finish setting up your account for <strong>{{ data.email }}</strong>.</p>
      <h2>Mobile Phone Number</h2>
      <p>A text message will be sent to your number to verify your identity when resetting your password.</p>
      <chc-input v-model="data.phone" label="Mobile Phone Number" :required="true" :error="errors.phone"></chc-input>
    </div>
    <div class="field">
      <h2>Password</h2>
      <p>Your password should contain at least 8 characters.</p>
      <chc-input v-model="data.password" type="password" label="Password" :required="true" :error="errors.password"></chc-input>
      <chc-input v-on:enter="login" v-model="data.password_confirmation" type="password" label="Confirm Password" :required="true" :error="errors.password_confirmation"></chc-input>
    </div>
    <span v-if="hasErrors" class="error-message error-block">
        There were errors processing the form. Please fix the fields above.
      </span>
    <div class="field buttons">
      <input type="submit" class="btn" value="Save" @click="login">
    </div>
  </section>
</div>
</template>

<script>
import ChcHeader from '@/components/ChcHeader'
import Navbar from '@/components/Navbar'
import store from '@/store'

export default {
  name: 'NewUserSetup',
  data () {
    return {
      data: {
        email: '',
        goodToken: false
      },
      errors: {},
      hasErrors: false
    }
  },
  props: ['token'],
  beforeRouteEnter (to, from, next) {
    store.functions.newuser.newUserInitialRegister({token: to.params.token}, (response) => {
      next()
    }).then((response) => {
      if (response.data.login) {
        window.location.href = '/'
        return
      }
      next(vm => vm.setData(response.data, to.params.token))
    }).catch(() => {
      next()
    })
  },
  methods: {
    setData (data, token) {
      this.data.token = token
      this.data.goodToken = true
      this.data.email = data.email
    },
    login () {
      store.functions.newuser.newUserRegister(this.data, (err) => {
        console.log(err)
        this.errors = err
        this.hasErrors = true
      }).then(() => {
        window.location.href = '/'
      })
    },
  },
  components: {
    ChcHeader,
    Navbar
  }
}
</script>

<style scoped>
section {
    margin-top: 3em;
}
</style>



// WEBPACK FOOTER //
// src/components/Login/NewUserSetup.vue